export default __webpack_public_path__ + "static/media/tete84.737965b5.png";